<template>
  <b-modal
    ref="modal"
    size="xl"
    title="Create Hybrid Category"
    title-class="font-18"
    :no-close-on-backdrop="true"
    hide-footer
    @hidden="$emit('hidden')"
    scrollable
  >
    <validationObserver ref="createView">
      <b-form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset">
        <b-form-group
          label="Root"
          label-for="input_root"
          label-cols-sm="3"
          v-if="level !== 1"
        >
          <label class="col-form-label col-sm-7">{{ root }}</label>
        </b-form-group>
        <validationProvider
          v-slot="{ errors }"
          name="Thai Name"
          :rules="{
            dynamicRequired: ['กรุณาระบุชื่อหมวดหมู่เป็นภาษาไทย'],
            duplicateName: [
              isValidate.display_name_th,
              'ชื่อหมวดหมู่ภาษาไทยซ้ำกับข้อมูลที่อยู่ในระบบ',
            ],
            validateWithSpecialCharacters: true,
          }"
        >
          <div class="form-row form-group">
            <label class="col-sm-3 col-form-label">ชื่อ (ไทย)</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input
                  id="input_displayname_th"
                  name="input_displayname_th"
                  type="text"
                  class="form-control"
                  placeholder="ระบุชื่อหมวดหมู่ภาษาไทย"
                  v-model="input.display_name.th"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) && input.display_name.th,
                  }"
                  v-on:keyup="onValidateDisplaynameTH($event)"
                />
                <span class="input-validate-length">
                  {{ input.display_name.th.length }}
                </span>
              </div>
              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </div>
        </validationProvider>
        <validationProvider
          v-slot="{ errors }"
          name="English Name"
          :rules="{
            dynamicRequired: ['กรุณาระบุชื่อหมวดหมู่เป็นภาษาอังกฤษ'],
            duplicateName: [
              isValidate.display_name_en,
              'ชื่อหมวดหมู่ภาษาอังกฤษซ้ำกับข้อมูลที่อยู่ในระบบ',
            ],
            validateEngWithSpecialCharacters: true,
          }"
        >
          <div class="form-row form-group">
            <label class="col-sm-3 col-form-label">ชื่อ (อังกฤษ)</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input
                  id="input_displayname_en"
                  name="input_displayname_en"
                  type="text"
                  class="form-control"
                  placeholder="ระบุชื่อหมวดหมู่ภาษาอังกฤษ"
                  v-model="input.display_name.en"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) && input.display_name.en,
                  }"
                  v-on:keyup="onValidateDisplaynameEN($event)"
                />
                <span class="input-validate-length">
                  {{ input.display_name.en.length }}
                </span>
              </div>
              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </div>
        </validationProvider>
        <validationProvider
          v-slot="{ errors }"
          name="Commission Rate"
          :rules="{
            dynamicRequired: ['กรุณาระบุ Commission Rate'],
            duplicateName: [
              isValidate.commission_rate,
              'กรุณาระบุ Commission Rate ไม่เกิน 100%',
            ],
            validateNum2Decimal: true,
          }"
        >
          <div class="form-row form-group">
            <label class="col-sm-3 col-form-label">Commission Rate (%)</label>
            <div class="col-sm-5">
              <input
                type="number"
                step=".01"
                v-model="input.commission_rate"
                placeholder="ระบุ Commission Rate"
                class="form-control"
                :class="{
                  'is-invalid': errors && errors.length,
                  'is-valid':
                    !(errors && errors.length) && input.input_commission_rate,
                }"
                @keyup="onValidateCommissionRate($event)"
              />
              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </div>
        </validationProvider>
        <validationProvider
          v-slot="{ errors }"
          name="Status"
          :rules="{ dynamicRequired: ['กรุณาเลือกสถานะ'] }"
        >
          <b-form-group
            label="สถานะ"
            label-for="input_status"
            label-cols-sm="3"
          >
            <div class="row col-sm-9 col-form-label">
              <!-- <b-form-radio
                v-model="input.status"
                name="input_status"
                class="custom-control custom-radio custom-radio-info mb-3"
                value="Active"
                style="margin-right:10px;"
                >Active</b-form-radio
              >
              <b-form-radio
                v-model="input.status"
                name="input_status"
                class="custom-control custom-radio custom-radio-info mb-3"
                value="Inactive"
                >Inactive</b-form-radio
              > -->
              <b-form-radio-group
                v-model="status"
                :disabled="!isStatusActiveParent"
              >
                <b-form-radio value="Active">Active</b-form-radio>
                <b-form-radio value="Inactive">Inactive</b-form-radio>
              </b-form-radio-group>
            </div>
            <div v-if="errors && errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <b-form-group
          label="สำหรับจัดการสินค้า"
          label-for="input_is_control_product"
          label-cols-sm="3"
        >
          <div class="row col-sm-9 col-form-label">
            <b-form-radio
              v-model="input.is_control_product"
              name="input_is_control_product"
              class="custom-control custom-radio custom-radio-info mb-3"
              :value="true"
              style="margin-right:10px;"
              >Yes</b-form-radio
            >
            <b-form-radio
              v-model="input.is_control_product"
              name="input_is_control_product"
              class="custom-control custom-radio custom-radio-info mb-3"
              :value="false"
              >No</b-form-radio
            >
          </div>
        </b-form-group>
        <div slot="modal-footer">
          <div class="button-items" style="float: right;">
            <button type="submit" class="btn btn-primary">
              <i class="bx bx-save" />Save
            </button>
            <button type="reset" class="btn btn-light">
              <i class="bx bx-reset" />Reset
            </button>
          </div>
          <!-- <button
            type="submit"
            class="btn btn-primary"
            style="float: right;"
          >
            Save
          </button>
          <button type="reset" class="btn btn-secondary"  style="float: right;">
            Reset
          </button> -->
        </div>
      </b-form>
    </validationObserver>
  </b-modal>
</template>
<script>
import Vue from 'vue'
import hybridCategoryService from '@/helpers/service/hybrid-category-service'
import { StatusEnum } from '@/enum/status.enum.js'
import { eventBus } from '@/main.js'
export default {
  components: {},
  props: {
    activeModal: {
      type: Boolean,
      default: false,
    },
    parent_id: {
      type: String,
      default: null,
    },
    level: {
      type: Number,
      default: 0,
    },
    root: {
      type: String,
      default: null,
    },
    commission_rate: {
      type: String,
      default: null,
    },
    parent_status: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      openModal: false,
      input: {
        id: null,
        parent_id: null,
        level: 0,
        code: null,
        display_name: {
          th: '',
          en: '',
        },
        commission_rate: null,
        is_control_product: false,
        is_commission_rate: false,
        status: StatusEnum.ACTIVE,
        categories_mapped: [],
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
      },
      isValidate: {
        display_name_th: false,
        display_name_en: false,
        commission_rate: false,
      },
      status: '',
    }
  },
  watch: {
    activeModal: function(value) {
      if (value) {
        this.$refs.modal.show()
        this.input = {
          id: null,
          parent_id: null,
          level: 0,
          code: null,
          display_name: {
            th: '',
            en: '',
          },
          commission_rate: this.commission_rate,
          is_control_product: false,
          is_commission_rate: false,
          status: StatusEnum.ACTIVE,
          categories_mapped: [],
          create_info: {
            timestamp: '',
            user_id: '',
            user_name: '',
          },
          update_info: {
            timestamp: '',
            user_id: '',
            user_name: '',
          },
        }
        this.isValidate = {
          display_name_th: false,
          display_name_en: false,
          commission_rate: false,
        }
      } else {
        this.$refs.modal.hide()
      }
    },
    parent_status: function(value) {
      if (value) {
        this.status = value
      }
    },
  },
  computed: {
    isStatusActiveParent() {
      return this.parent_status === '' || this.parent_status === 'Active'
    },
  },
  methods: {
    onSubmit() {
      this.$refs.createView.validate().then(result => {
        if (result) {
          this.input.display_name.th = this.input.display_name.th.trim()
          this.input.display_name.en = this.input.display_name.en.trim()
          this.input.status = this.status
          this.$emit('createView', this.input)
        }
      })
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.status = ''
            this.input = {
              id: null,
              parent_id: null,
              level: 0,
              code: null,
              display_name: {
                th: '',
                en: '',
              },
              commission_rate: this.commission_rate,
              is_control_product: false,
              is_commission_rate: false,
              status: StatusEnum.ACTIVE,
              categories_mapped: [],
              create_info: {
                timestamp: '',
                user_id: '',
                user_name: '',
              },
              update_info: {
                timestamp: '',
                user_id: '',
                user_name: '',
              },
            }
            this.isValidate = {
              display_name_th: false,
              display_name_en: false,
              commission_rate: false,
            }
          }
        })
    },
    async onValidateDisplaynameTH() {
      if (
        !(
          this.input.display_name.th.trim() === '' ||
          this.input.display_name.th.trim() === null ||
          this.input.display_name.th.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameTH', this.input.display_name.th.trim())
        if (this.parent_id !== null) {
          params.append('parent_id', this.parent_id)
        }
        let result = await hybridCategoryService.headHybridCategoryAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name_th = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_th = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateDisplaynameEN() {
      if (
        !(
          this.input.display_name.en.trim() === '' ||
          this.input.display_name.en.trim() === null ||
          this.input.display_name.en.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameEN', this.input.display_name.en.trim())
        if (this.parent_id !== null) {
          params.append('parent_id', this.parent_id)
        }
        let result = await hybridCategoryService.headHybridCategoryAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name_en = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_en = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    onValidateCommissionRate() {
      if (
        !(
          this.input.commission_rate.trim() === '' ||
          this.input.commission_rate.trim() === null ||
          this.input.commission_rate.trim() === undefined
        )
      ) {
        if (Number(this.input.commission_rate.trim()) > 100) {
          this.isValidate.commission_rate = true
        } else {
          this.isValidate.commission_rate = false
        }
      }
    },
  },
}
</script>
